module.exports = __webpack_public_path__ + "static/assets/7b0d49651fc02f8918105f26afc907a9.svg";